"use client"

import { useState } from "react";
import { cn } from "~/lib/utils";

interface ThumbnailProps {
  src: string;
  alt: string;
  icon: boolean
}

export default function Thumbnail({ src, alt, icon }: ThumbnailProps) {
  const [imgSrc, setImgSrc] = useState(src);

  return (
    <div
      className={cn("flex items-center justify-center rounded-2xl w-full")} 
    >
      <img
        className={cn("aspect-square max-h-48 w-full max-w-52 object-cover", icon && "brightness-0 invert")}
        src={imgSrc}
        alt={alt}
        onError={() => setImgSrc("/icons/contact.webp")}
      />
    </div>
  );
}
